import React from 'react';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';

interface Props {
  label: string;
  value: number | string | null;
}

export const ReviewItem = ({ label, value }: Props) => {
  return (
    <Box
      as="li"
      display="grid"
      alignItems="center"
      css="grid-template-columns: 1fr 1fr"
      px="32"
      py="8"
      borderBottom="1px solid"
      borderColor="neutral.200"
      height={48}
    >
      <Text fontWeight={500} color="neutral.500">
        {label}
      </Text>

      <Text fontWeight={500}>{value ?? '—'}</Text>
    </Box>
  );
};
